<template>
  <section>
    <h2>{{ $t('contest.section.ranks.title') }}</h2>
    <div class="contest ranks">
      <div class="item box" v-if="users.length > 0" v-for="user in users" :key="user.id">
        <div class="nickname">{{ user.nickname }}</div>
        <div class="avatar">
          <img :src="user.mediaurl" alt="">
        </div>
        <div class="rank">{{ user.rank }}</div>
        <div class="score">
          <span>{{ user.score }} pts</span>
        </div>
      </div>
    </div>
    <div class="end-page-buttons">
      <button @click="loadMore">{{ $t('contest.section.ranks.button.load-more') }}</button>
      <button @click="download">{{ $t('contest.section.ranks.button.download') }}</button>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'contest-ranking',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      users: [],
      page: 0
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('contest', {
      getById: 'getById'
    })
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    ...mapActions('contest', ['loadContest', 'getContestRankByPage']),

    init () {
      this.getContestRankByPage({id: this.id, page: this.page})
        .then((result) => {
          this.users.push(...result)
        }).catch(() => {
          this.$vs.notify({text: 'An error has occured', color: 'danger', icon: 'check', position: 'top-right'})
        })
    },

    loadMore () {
      this.page++
      this.getContestRankByPage({id: this.id, page: this.page})
        .then((result) => {
          this.users.push(...result)
        }).catch(() => {
          this.$vs.notify({text: 'An error has occured', color: 'danger', icon: 'check', position: 'top-right'})
        })
    },

    download () {
      const token = btoa(localStorage.getItem('token'));
      const url = process.env.API+'/contest/export/'+ this.site.sitekey +'/contest/' + this.id + `/?xtoken=${token}`;
      window.open(url, '_blank');
    }
  }
}

</script>

<style lang="scss" scoped>
h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
}
.ranks {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, auto));
    grid-gap: 24px;
    margin-bottom:40px;

    .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 10px;

        .avatar {
            display: flex;
            justify-content: center;

            img {
                max-width: 80%;
                max-height: 50px;
                border-radius: 8px;
            }
        }
        .nickname {
            font-weight: 600;
            text-align:center;
            font-size: 18px;
        }

        .rank {
            font-weight: 600;
            font-size: 30px;
            text-align: center;
        }
        .score {
            span {
                display: inline-block;
                background: #efefef;
                border-radius: 3px;
                padding: 4px 8px;
                font-size: 10px;
            }
        }
    }

}
.end-page-buttons {
    padding:24px 0;
    text-align: center;
    button {
        background: #fff;
        border:1px solid #dadada;
        height: 40px;
        padding: 4px 18px;
        font-weight: bold;
        color:#999;
        border-radius: 40px;

        &:hover {
            border:1px solid #999;
            color:#565656;
            cursor: pointer;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/contests/contest-ranking.vue